
// Replace New Lines With <BR /> Tags
export default (input) => {
  return input?.replace(/(?:\r\n|\r|\n)/g, '<br />');
}
